import { CtaClick } from "../Analytics";
import { Table } from "antd";
export const TopCtas = ({
  data,
  firstPlay,
}: {
  data?: {
    totalSessionsWithClicks: number;
    clicks: Array<CtaClick>;
  } | null;
  firstPlay?: number;
}) => {
  if (!data) return null;
  const totalPlays = firstPlay || 0;
  const processedData = data.clicks.filter((c) => c.ctaName !== "no-cta");
  const totalCtas = processedData.reduce(
    (prev, curr) => prev + curr.uniqueSessions,
    0
  );
  return processedData.length ? (
    <div className="analytics-view top-cta" style={{ height: "fit-content" }}>
      <div className="view-title">
        <h2>Conversion</h2>
      </div>
      <div className="content">
        <table width={"100%"}>
          <tbody>
            <tr>
              <td style={{ verticalAlign: "top" }}>
                <h3>Converting Sessions: {data.totalSessionsWithClicks}</h3>
              </td>
              <td
                style={{
                  textAlign: "end",
                  paddingRight: "1rem",
                  display: "flex",
                  flexDirection: "row-reverse",
                  paddingBottom: ".5rem",
                }}
              >
                <div className="out-of-group">
                  <span className="percentage">
                    {totalPlays > 0
                      ? (
                          (data.totalSessionsWithClicks / totalPlays) *
                          100
                        ).toFixed(1)
                      : "0.0"}
                    %
                  </span>
                  <span className="out-of">Out of Play</span>
                </div>
              </td>
            </tr>
            <tr style={{ borderTop: ".5px solid black" }}>
              <td>
                <h3>Top CTAs</h3>
              </td>
              <td style={{ textAlign: "end", paddingRight: "1rem" }}>
                <h4>Total {totalCtas.toLocaleString("en-US")}</h4>
              </td>
            </tr>
          </tbody>
        </table>

        <Table
          pagination={false}
          style={{ overflow: "hidden" }}
          scroll={{ y: "180px" }}
          dataSource={[...processedData]
            .sort((a, b) => b.uniqueSessions - a.uniqueSessions)
            .map((d) => ({
              key: d.ctaName,
              clicks: `${d.uniqueSessions}`,
            }))}
          columns={[
            {
              title: "Name",
              key: "key",
              dataIndex: "key",
            },
            {
              title: "Clicks",
              key: "clicks",
              dataIndex: "clicks",
            },
          ]}
        />
      </div>
    </div>
  ) : null;
};
